// Angular Modules.
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import {
  NoopAnimationsModule,
  ANIMATION_MODULE_TYPE,
  BrowserAnimationsModule,
} from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterLink, RouterModule } from '@angular/router';

// External Modules and Services.
import { AppRoutingModule, routes } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// API Services
// TODO: Register Services as @Injectable({ providedIn: 'root' })
import { ConfigService } from './services/config/config.service';
import { TokenService } from './services/token/token.service';
import { ApiService } from './services/apiservice/apiservice.service';
import { StorageService } from './services/storage/storage.service';
import { AuthService } from './services/auth/auth.service';
import { SharedService } from './services/shared/shared.service';
import { RoutingService } from './services/routing/routing.service';
import { LibraryService } from './services/library/library.service';

// App
import { AppComponent } from './app.component';

// Layouts
import { MainV6LayoutComponent } from './layouts/main-v6-layout/main-v6-layout.component';

// Pages and Route Components.
import { DetailsComponent } from './pages/details/details.component';
import { OnlineContentComponent } from './pages/details/online-content/online-content.component';
import { FooterComponent } from './pages/footer/footer.component';
import { HeaderComponent } from './pages/header/header.component';
import { LoginPageComponent } from './pages/login/login.component';

// Guards
import { AuthGuard, AuthGuardStaff, AuthGuardStaffPatron } from './core/guards/auth.guard';
import { RequestGuard } from './core/guards/request.guard';
import { LoginGuard } from './core/guards/login.guard';

// Popups and Non Routes
import { IllLimitInfoDialog } from './pages/request/dialogs/ill-limit-info-dialog/ill-limit-info-dialog.component';
import { CopyRightDialog } from './pages/request/dialogs/copy-right-dialog/copy-right-dialog.component';
import { DuplicateCheckDialog } from './pages/request/dialogs/duplicate-check-dialog/duplicate-check-dialog.component';
import { SubmitRequestDialog } from './pages/request/dialogs/submit-request-dialog/submit-request-dialog.component';
import { AskRedirectDialog } from './pages/request/dialogs/ask-redirect-dialog/ask-redirect-dialog.component';
import { DoNotPlaceHoldDialog } from './pages/request/dialogs/do-not-place-hold-dialog/do-not-place-hold-dialog.component';
import { BibRecordDialog } from './pages/details/dialogs/bib-record-dialog/bib-record-dialog.component';
import { ErrorBibDialog } from './pages/details/dialogs/error-bib-dialog/error-bib-dialog.component';

// Services
import { AccountService } from './pages/account/account.service';
import { AdvancedSearchService } from './pages/advancedsearch/advancedsearch.service';
import { DashboardService } from './pages/dashboard/dashboard.service';
import {
  RequestInterceptorService,
  DEFAULT_TIMEOUT,
} from './core/interceptors/request-interceptor.service';
import { HoldService } from './pages/hold/hold.service';
import { ItemsDetailsService } from './pages/item-details/item-details.service';
import { RequestService } from './pages/request/request.service';
import { SearchHistoryService } from './components/side-nav/search-history/search-history.service';
import { StaffFullRecordService } from './components/side-nav/staff-full-record/staff-full-record.service';
import { SettingsService } from './components/your-settings/your-settings.service';
import { YourListService } from './pages/your-list/your-list.service';

// Home services imported
import { DetailsService } from './pages/details/details.service';
import { GalleryViewService } from './components/search/gallery-view/gallery-view.service';
import { GoogleMapService } from './services/home-services/google-map/google-map.service';
import { OpacSettingsService } from './services/opac-settings/opac-settings.service';
import { SearchService } from './services/search/search.service';
import { SetComponentsService } from './services/edit/set-components.service';
import { YoutubeService } from './services/home-services/youtube/youtube.service';
import { AppendCompService } from './services/edit/append-comp.service';
import { PredefinedTemplatesService } from './services/edit/predefined-templates.service';
import { EditComponentComponent } from './components/edits/edit-component/edit-component.component';
import { PatronLookupService } from './pages/patron-lookup/patron-lookup.service';
// temp spot new files will be moved.

import { QuickMenuService } from './components/side-nav/quick-menu/quick-menu.service';
import { RegisterComponent } from './pages/details/register/register/register.component';
import { DownloadFormatDialog } from './pages/your-list/dialogs/download-format-dialog/download-format-dialog.component';
import { SessionExpiryDialog } from './pages/header/dialogs/session-expiry-dialog/session-expiry-dialog.component';
import { StaffSubmitDialog } from './pages/hold/dialogs/staff-submit-dialog/staff-submit-dialog.component';
import { MultiplePatronSubmitDialog } from './pages/your-list/dialogs/multiple-patron-submit-dialog/multiple-patron-submit.component';
import { KidsCatalogSearchService } from './pages/kids-catalog-search/kids-catalog-search.service';
import { EditSidenavService } from './components/edits/edit-sidenav/edit-sidenav.service';
import { ExcelService } from './services/excel/excel.service';
import { RequestSubmitRbDailog } from './pages/details/register/request-submit-rb-dailog/request-submit-rb-dailog.component';
import { ListShareDialogComponent } from './pages/header/dialogs/list-share-dialog/list-share-dialog.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

//
// Google Translate for Angular
//

// https://ctrlq.org/code/19899-google-translate-languages
//https://www.youtube.com/watch?v=Ara2cQ4IQxA
//https://medium.com/letsboot/translate-angular-4-apps-with-ngx-translate-83302fb6c10d

// translate pakages
import { PatronLookupModule } from './pages/patron-lookup/patron-lookup.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BxDailog } from './pages/details/dialogs/bx-dialog/bx-dailog/bx-dailog.component';
import { ChangePasswordDialogComponent } from './pages/login/dialogs/changepassdialog/changepassdialog.component';
import { ValidateLendersDialog } from './pages/request/dialogs/validate-lenders-dialog/validate-lenders-dialog.component';
import { OpenSearchComponent } from './pages/search/open-search/open-search/open-search.component';
import { NoPasswordDialog } from './pages/login/dialogs/no-pwdialog/no-pwdialog.component';
import { ColorsService } from './services/colors/colors.service';
import { NotifyService } from './components/side-nav/notify/notify.service';
import { GiploginComponent } from './pages/login/giplogin/giplogin.component';
import { SamlComponent } from './pages/login/saml/saml.component';
import { SamlSnackbar } from './pages/login/dialogs/saml-snackbar/saml-snackbar.component';
import { BlockUserDialog } from './pages/login/dialogs/block-user-dialog/block-user-dialog.component';
import { HoldingsDetailsDialog } from './pages/details/dialogs/holdings-details-dialog/holdings-details-dialog.component';
import { SharedModule } from './shared/shared.module';
import { PipesSharedModule } from './shared/pipes/pipes.module';
import { LegacyStaffModule } from './modules/shared/staff/legacy-staff.module';
import { HoldSharedModule } from './modules/shared/hold-shared/hold-shared.module';
import { ColumnsSharedModule } from './modules/shared/columns-shared/columns-shared.module';
import { HomeComponentsSharedModule } from './modules/shared/home-components-shared/home-components-shared.module';
import { QuickMenuComponent } from './components/side-nav/quick-menu/quick-menu.component';
import { PrintDialog } from './pages/search/print-dialog/print-dialog.component';
import { AdvancedProgressSpinnerDialog } from './pages/advancedsearch/dialogs/advanced-progress-spinner-dialog/advanced-progress-spinner-dialog.component';
import { DirectiveModule } from './shared/directives/directive.module';
import { PatronExpiryMsgDialog } from './pages/login/dialogs/patron-expiry-msg-dialog/patron-expiry-msg-dialog.component';
import { BrowseModule } from './pages/browse/browse.module';
import { LibraryCardComponent } from './components/side-nav/library-card/library-card.component';
import { LayoutModule } from '@angular/cdk/layout';
import { EContentService } from './services/thirdparty/econtent.service';
import { OverDriveService } from './services/thirdparty/overdrive/overdrive.service';
import { WebSocketService } from './services/websocket/websocket.service';
import { AgFieldsModule } from './shared/directives/ag-fields/ag-fields.module';
import { ScriptsService } from './services/scripts/scripts.service';
import { DownloadItemCopyRightDialog } from './components/item-details/dialogs/download-item-copy-right-dialog/download-item-copy-right-dialog.component';
import { OverDriveFullRecordComponent } from './pages/details/third-party/overdrive/overdrive-fullrecord.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { HooplaFullRecordComponent } from './pages/details/third-party/hoopla/hoopla-fullrecord.component';
import { NovelistFullRecordComponent } from './pages/details/third-party/novelist/novelist-fullrecord.component';
import { SyndeticsFullRecordComponent } from './pages/details/third-party/syndetics/syndetics-fullrecord.component';
import { CirculationConfigDialog } from './pages/circulation/locationgroups/config-dialog/config-dialog.component';
import { DeleteGroupDialog } from './pages/circulation/locationgroups/delete-group-dialog/delete-group-dialog.component';
import { WidgetLayoutComponent } from './layouts/widget-layout/widget-layout.component';
import { PrintLayoutComponent } from './layouts/print-layout/print-layout.component';
import { MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/legacy-tooltip';
import { ClcdModule } from './pages/details/third-party/clcd/clcd.module';
import { OverdriveMagazineDialogComponent } from './pages/details/third-party/overdrive/overdrive-magazine-dialog/overdrive-magazine-dialog.component';
import { HoldingFormComponent } from './pages/holdings/holding-form/holding-form.component';
import { ItemActionsComponent } from './pages/details/item-actions/item-actions.component';
import { ItemActionsDropdownComponent } from './pages/details/item-actions/item-actions-dropdown.component';
import { ItemActionsListComponent } from './pages/details/item-actions/item-actions-list.component';
import { ItemActionsToolbarDropdownComponent } from './pages/details/item-actions/item-actions-toolbar-dropdown.component';
import { MenuItemsActionsComponent } from './pages/details/item-actions/menu-items-actions.component';
import { register } from 'swiper/element/bundle';
import { HoldingsManagementComponent } from './pages/holdings/holdings-management/holdings-management.component';
import { AuditHistoryModule } from './components/audit-history/audit-history.module';
import { UserService } from './pages/staff/users/user.service';
const defaultTimeout = 120000;
register();

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    QuickMenuComponent,
    DetailsComponent,
    LoginPageComponent,
    RegisterComponent,
    EditComponentComponent,
    OpenSearchComponent,
    GiploginComponent,
    SamlComponent,
    // Pop-ups and other Non-routes
    IllLimitInfoDialog,
    CopyRightDialog,
    DuplicateCheckDialog,
    SubmitRequestDialog,
    AskRedirectDialog,
    DoNotPlaceHoldDialog,
    BibRecordDialog,
    ErrorBibDialog,
    DownloadFormatDialog,
    SessionExpiryDialog,
    StaffSubmitDialog,
    MultiplePatronSubmitDialog,
    RequestSubmitRbDailog,
    BxDailog,
    BlockUserDialog,
    HoldingsDetailsDialog,
    AdvancedProgressSpinnerDialog,
    ChangePasswordDialogComponent,
    ValidateLendersDialog,
    PrintDialog,
    NoPasswordDialog,
    SamlSnackbar,
    PatronExpiryMsgDialog,
    DownloadItemCopyRightDialog,
    CirculationConfigDialog,
    DeleteGroupDialog,
    LibraryCardComponent,
    ListShareDialogComponent,
    OverDriveFullRecordComponent,
    HooplaFullRecordComponent,
    NovelistFullRecordComponent,
    SyndeticsFullRecordComponent,
    MainV6LayoutComponent,
    WidgetLayoutComponent,
    PrintLayoutComponent,
    OverdriveMagazineDialogComponent,
    HoldingFormComponent,
    HoldingsManagementComponent,
    ItemActionsComponent,
    ItemActionsDropdownComponent,
    ItemActionsListComponent,
    ItemActionsToolbarDropdownComponent,
    MenuItemsActionsComponent,
    OnlineContentComponent,
  ],
  imports: [
    DirectiveModule,
    HomeComponentsSharedModule,
    ColumnsSharedModule,
    LegacyStaffModule,
    PipesSharedModule,
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot(routes, { useHash: false }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NoopAnimationsModule,
    HoldSharedModule,
    ComponentsModule,
    NgbModule,
    PatronLookupModule,
    SharedModule,
    BrowseModule,
    AgFieldsModule,
    FlexLayoutModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LayoutModule,
    BrowserAnimationsModule,
    ClcdModule,
    AuditHistoryModule,
  ],
  providers: [
    // Guards
    AuthGuard,
    AuthGuardStaff,
    AuthGuardStaffPatron,
    RequestGuard,
    LoginGuard,
    AppendCompService,
    ApiService,
    AccountService,
    AuthService,
    EContentService,
    OverDriveService,
    ConfigService,
    ColorsService,
    LibraryService,
    DashboardService,
    DetailsService,
    EditComponentComponent,
    GalleryViewService,
    GoogleMapService,
    HoldService,
    ItemsDetailsService,
    NotifyService,
    PatronLookupService,
    PredefinedTemplatesService,
    RequestService,
    SearchService,
    SearchHistoryService,
    SetComponentsService,
    SettingsService,
    SharedService,
    RoutingService,
    StaffFullRecordService,
    StorageService,
    TokenService,
    YourListService,
    YoutubeService,
    AdvancedSearchService,
    OpacSettingsService,
    QuickMenuService,
    KidsCatalogSearchService,
    EditSidenavService,
    ExcelService,
    ScriptsService,
    UserService,
    Title,
    RouterLink,
    WebSocketService,
    DatePipe,
    DecimalPipe,
    { provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
    { provide: DEFAULT_TIMEOUT, useValue: defaultTimeout },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 750,
        disableTooltipInteractivity: true,
      },
    },
  ],
  exports: [
    PipesSharedModule,
    SharedModule,
    ComponentsModule,
    ClcdModule,
    //Dialogs
    IllLimitInfoDialog,
    CopyRightDialog,
    DuplicateCheckDialog,
    SubmitRequestDialog,
    AskRedirectDialog,
    DoNotPlaceHoldDialog,
    BibRecordDialog,
    ErrorBibDialog,
    DownloadFormatDialog,
    SessionExpiryDialog,
    StaffSubmitDialog,
    MultiplePatronSubmitDialog,
    RequestSubmitRbDailog,
    BxDailog,
    HoldingsDetailsDialog,
    PatronExpiryMsgDialog,
    DownloadItemCopyRightDialog,
    CirculationConfigDialog,
    DeleteGroupDialog,
    AuditHistoryModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
